import { useState, Suspense } from 'react'
import { Form, useActionData, useRouteLoaderData, useParams, useNavigation, Link, Await } from 'react-router-dom';
import AdminPlatformPoliciesForm from '../../components/admin/AdminPlatformPoliciesForm.jsx'
import AdminPlatformPoliciesShow from '../../components/admin/AdminPlatformPoliciesShow.jsx'
import { ListTeams } from '../../repo/TeamsRepo.js'
import { GetTournament } from '../../repo/TournamentsRepo.js'
import { CreatePlatformPolicy } from '../../repo/PlatformPoliciesRepo.js'

export default function PlatformPolicyNewPage() {
  const {tournamentId} = useParams()
  const response = useActionData()
  const platformPolicyRelations = useRouteLoaderData('admin-platform-policy-new')
  const createNavigation = useNavigation()
  const isSubmitting = createNavigation.state === 'submitting'
  const [tournament, setTournament] = useState(platformPolicyRelations.tournament)

  return (
    <section className="m-8">
      {response && response.status && response.status  ? (
        <AdminPlatformPoliciesShow tournament={tournament} platformPolicy={response.data} status="created"/>
      ) : (
        <>
          <h1>Create New Platform Policy: { tournament ? tournament.name + ' ' + tournament.edition : '' } </h1>
          <div id="platform-policy-create-form" className={`w-full py-4 mb-4'`}>
            <Form method="POST" className="space-y-4 md:space-y-6 mt-4">
              <Suspense fallback={<p>Carregando...</p>}>
                <Await resolve={platformPolicyRelations}>
                  {(loadedPlatformPolicyRelations) => <AdminPlatformPoliciesForm tournament={loadedPlatformPolicyRelations.tournament} errors={(response && response.errors) ? response.errors : null } isSubmitting={isSubmitting}/>}
                </Await>
              </Suspense>
            </Form>
          </div>

          <div id="platform-policies" className={`w-full pt-4 mt-4'`}>
            <Link className="hover:no-underline underline" to={`/cocofantoelefanto/tournaments/${tournamentId}/platform-policies`}>Back to Platform Policies</Link>
          </div>
        </>
      )}
    </section>
  )
}

export async function action({request}) {
  const data = await request.formData()

  const platformPolicyData = {
    platform_name: data.get('platform_name'),
    restriction: data.get('restriction'),
    tournament_id: data.get('tournament_id'),
    description: data.get('description')
  }

  return CreatePlatformPolicy(platformPolicyData)
}


export async function loader({ params, request }) {
  return {
    tournament: await GetTournament(params.tournamentId)
  }
}
